/**
 * The responsibility of ContinuousDayEvent component is to renders a form for setting up an event that spans multiple days
 *
 * @returns {JSX.Element} A form with date and time picker fields for event start and end
 */

import dayjs from 'dayjs';
import MuiDatePicker from '../../../../../../../../components/FormFields/MuiDatePicker';
import MuiTimePicker from '../../../../../../../../components/FormFields/MuiTimePicker';
import { H6 } from '../../../../../../../../themes/typography';

function ContinuousDayEvent({ formik, isEditModeOn }) {
    return (
        <form
            className="onetime-event-schedule-container"
            onSubmit={formik.handleSubmit}
            noValidate
        >
            <div className="start-date-schedule-wrapper">
                <div className="start-date-schedule-container">
                    <div className="schedule-selection-title">
                        <H6>Start Date & Time</H6>
                    </div>
                    <div className="start-date-time-container">
                        <div className="start-date-input-container">
                            <MuiDatePicker
                                fullWidth
                                id="startDate"
                                name="startDate"
                                label="Start Date *"
                                format="DD/MM/YYYY"
                                disabled={!isEditModeOn}
                                value={formik.values.startDate}
                                onChange={(date) => formik.setFieldValue('startDate', date)}
                                error={formik.touched.startDate && Boolean(formik.errors.startDate)}
                                helperText={formik.touched.startDate && formik.errors.startDate}
                            />
                        </div>
                        <div className="start-date-input-container">
                            <MuiTimePicker
                                fullWidth
                                id="startTime"
                                name="startTime"
                                label="Start Time *"
                                format="HH:mm"
                                minTime={
                                    dayjs(formik.values.startDate, 'DD/MM/YYYY').isSame(
                                        dayjs(),
                                        'day'
                                    )
                                        ? dayjs().add(1, 'hour')
                                        : dayjs().startOf('day')
                                }
                                value={formik.values.startTime}
                                disabled={!isEditModeOn}
                                onChange={(time) => formik.setFieldValue('startTime', time)}
                                error={formik.touched.startTime && Boolean(formik.errors.startTime)}
                                helperText={formik.touched.startTime && formik.errors.startTime}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="start-date-schedule-wrapper">
                <div className="start-date-schedule-container">
                    <div className="schedule-selection-title">
                        <H6>End Date & Time</H6>
                    </div>
                    <div className="start-date-time-container">
                        <div className="start-date-input-container">
                            <MuiDatePicker
                                fullWidth
                                id="endDate"
                                name="endDate"
                                label="End Date *"
                                format="DD/MM/YYYY"
                                disabled={!isEditModeOn}
                                minDate={dayjs(formik.values.startDate)}
                                value={formik.values.endDate}
                                onChange={(date) => formik.setFieldValue('endDate', date)}
                                error={formik.touched.endDate && Boolean(formik.errors.endDate)}
                                helperText={formik.touched.endDate && formik.errors.endDate}
                            />
                        </div>
                        <div className="start-date-input-container">
                            <MuiTimePicker
                                fullWidth
                                id="endTime"
                                name="endTime"
                                label="End Time *"
                                format="HH:mm"
                                minTime={
                                    dayjs(formik.values.startDate).isSame(
                                        formik.values.endDate,
                                        'day'
                                    )
                                        ? dayjs(formik.values.startTime).add(30, 'minute')
                                        : dayjs().startOf('day')
                                }
                                disabled={!isEditModeOn}
                                value={formik.values.endTime}
                                onChange={(time) => formik.setFieldValue('endTime', time)}
                                error={formik.touched.endTime && Boolean(formik.errors.endTime)}
                                helperText={formik.touched.endTime && formik.errors.endTime}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default ContinuousDayEvent;
